module.exports = __webpack_public_path__ + "img/list-yes.ca01faa1.png";